/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type ProfileStatusModule_tradeFirm$ref = any;
type RewardsDashboardHeader_tradeFirm$ref = any;
type RewardsProgressModule_tradeFirm$ref = any;
type TpnOverview_tradeFirm$ref = any;
export type DesignProfileStatus = "ACTIVE" | "DELETED" | "NEW" | "PENDING" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type TpnRewardsDashboard_user$ref: FragmentReference;
export type TpnRewardsDashboard_user = {|
  +tradeFirm: ?{|
    +profileStatus: ?DesignProfileStatus,
    +rewards: ?{|
      +currentProgram: ?{|
        +programInfo: ?{|
          +code: ?string
        |}
      |}
    |},
    +$fragmentRefs: RewardsDashboardHeader_tradeFirm$ref & RewardsProgressModule_tradeFirm$ref & ProfileStatusModule_tradeFirm$ref & TpnOverview_tradeFirm$ref,
  |},
  +$refType: TpnRewardsDashboard_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "TpnRewardsDashboard_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "tradeFirm",
      "storageKey": null,
      "args": null,
      "concreteType": "TradeFirmType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "profileStatus",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "rewards",
          "storageKey": null,
          "args": null,
          "concreteType": "TradeFirmRewards",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "currentProgram",
              "storageKey": null,
              "args": null,
              "concreteType": "ParentProgram",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "programInfo",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "LoyaltyProgram",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "code",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "kind": "FragmentSpread",
          "name": "RewardsDashboardHeader_tradeFirm",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "RewardsProgressModule_tradeFirm",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "ProfileStatusModule_tradeFirm",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "TpnOverview_tradeFirm",
          "args": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'ce9c83a83d7fa9ae3cd1509d7a8bad3b';
module.exports = node;
